module.exports = __webpack_public_path__ + "static/media/GTL.25e9bf72.png";